import { createStore } from 'vuex'

export default createStore({
    state: {
        aid: '61c407203c9160005ac1c00d', // 活动id
        musicUrl: 'https://yunyingcdn.thecover.cn/o_1fne22mt521ih1mmu7f251gird.mp3',
        musicPaused: false, // 音乐播放状态
        userInfo: {}, // 用户信息
        shareData: {}, // 分享信息
        dialogData: null, // 弹框数据
        activityData: null, // 活动数据
        popData: null,
        videoData: null, // 视频数据
        picViewerData: null // 图片预览数据
    },
    mutations: {
        SET_MUSICURL (state, url: string) {
            state.musicUrl = url
        },
        SET_MUSICPAUSED (state, flag: boolean) {
            state.musicPaused = flag
        },
        SET_USERINFO (state, data) {
            state.userInfo = data
        },
        SET_SHAREDATA (state, data) {
            state.shareData = data
        },
        SET_DIALOGDATA (state, data) {
            state.dialogData = data
        },
        SET_ACTIVITYDATA (state, data) {
            state.activityData = data
        },
        SET_POPDATA (state, data) {
            state.popData = data
        },
        SET_VIDEODATA (state, data) {
            state.videoData = data
        },
        SET_PICVIEWERDATA (state, data) {
            state.picViewerData = data
        }
    },
    actions: {
    },
    modules: {
    }
})
